import printImage from "../../helpers/printImage"
import makeImageLabels from "../../helpers/makeImageLabels"
import { listLineship } from "../../helpers/filtersTable"
import { convertDateOverTimeNew } from "../../helpers/convertDateOverTime"

const _parseSize = (size) => {
    const vSize = size.replace(/\s/gi, '')
    const parsed = /(.+)(-NOCARD)(.?)/gi.exec(vSize)
    if (parsed) {
        return {
            size: parsed[1].trim(),
            noCard: true,
        }
    }

    return { size }
}

const _LineShipName = (lineShip) => {
    if (!!lineShip) {
        const mappingLineShips = [
            ...listLineship,
            { value: 'usps_mn_ib_blue', name: 'USPS-IB' },
            { value: 'ib_blue_usps_mn', name: 'IB-USPS' },
        ]
        const lineShipName = mappingLineShips.filter(item => item.value === lineShip)

        return lineShipName[0]
    }
}

const _parseLabel = (item, index) => {
    const usex = ['PR', 'AE', 'AP', 'AO', 'VI', 'AA']
    const { barcodeNumber, products, country, state, shipping_level, labelDetails, tags: genericTags = [], order_type } = { ...item }
    const isFastProduction = Array.isArray(genericTags) && genericTags.includes('fastproduction')
    const isCutoff = Array.isArray(genericTags) && genericTags.includes('cutoff')
    const isHQ = Array.isArray(genericTags) && (genericTags.includes('HQ') || genericTags.includes('HQ gap'))
    const hasCombineShipTag = genericTags.some(item => /^combine-ship(-\w+)?$/.test(item))
    const tagHasCombineShipId = genericTags.find(item => /^combine-ship-\w+$/.test(item)) || ''
    const combineShipId = !!tagHasCombineShipId ? tagHasCombineShipId.replace('combine-ship-', '') : ''
    const comboTag = genericTags.filter(i => ['BM_TC', 'BM_LAB', 'TC_LAB', 'BM_TC_LAB'].includes(i.toUpperCase()))
    const { shipping_carrier, meta } = { ...labelDetails }
    for (let i in products) {
        const product = products[i]

        if (parseInt(product.pos, 10) !== parseInt(index, 10)) {
            continue
        }
        const {
            color,
            size,
            designFront,
            designBack,
            designSleeveLeft,
            designSleeveRight,
            tags = [],
            brand_name,
            brand_rule,
            remaining_time,
            overtime,
        } = { ...product }
        const lineShipName = shipping_carrier ? (!!_LineShipName(shipping_carrier).name ? _LineShipName(shipping_carrier).name : '') : ''
        let line_ship_label = lineShipName === "ZONE9_US" ? "HW_Z9" : lineShipName === "ZONE9_CA" ? "Z9_CA" : lineShipName === "ITC Standard" ? "ITC DHL" : lineShipName
        let hwUSPSArea = ''

        if (['hw_usps', 'hw_tiktok', 'hw_ttship', 'hw_gb', 'hw_gb_ttship'].includes(shipping_carrier)) {
            const { area, box_name } = meta || {}
            const boxDetectedArea = (box_name && box_name.includes('-')) ? box_name.split('-').pop().trim() : ''
            hwUSPSArea = area || boxDetectedArea || (['hw_usps'].includes(shipping_carrier) ? 'NY' : '')
        }

        const brandName = brand_name ? brand_name : ''
        const isNoCard = brand_rule && brand_rule.is_no_card ? brand_rule.is_no_card : false
        const isSpecialTag = Array.isArray(tags) && tags.includes('priority-store')
        const { size: vSize, noCard } = _parseSize(size)
        const pos = product.hasOwnProperty('pos') ? product.pos : (i + 1)
        const side = `${designFront ? 'F' : ''}${designBack ? 'B' : ''}${(designSleeveLeft || designSleeveRight) ? '-' : ''}${designSleeveLeft ? 'L' : ''}${designSleeveRight ? 'R' : ''}`
        const type = product.type
        let loc = ''

        if (country.toUpperCase() === 'US' && usex.indexOf(state.toUpperCase()) !== -1) {
            loc = "WW"
        } else {
            loc = country.toUpperCase()
        }

        if (['HW_YUN'].includes(line_ship_label) && ['AT', 'CZ', 'DE', 'HU', 'IT', 'LU', 'NL', 'PL'].includes(loc) && !genericTags.includes('force-yun')) {
            line_ship_label = 'HW_EU'
        }

        return {
            orderId: `${barcodeNumber}_${pos}`,
            total: item.products.length,
            pos: pos,
            posColor: item.products.length > 1 ? 'white' : 'black',
            posBackground: item.products.length > 1 ? (isSpecialTag ? '#6d1212' : 'black') : 'white',
            color: color,
            size: vSize,
            side: side,
            sideBackground: side === 'F' ? (isSpecialTag ? '#6d1212' : 'white') : (isSpecialTag ? '#6d1212' : 'black'),
            sideColor: side === 'F' ? (isSpecialTag ? 'white' : 'black') : 'white',
            type: type,
            noCard,
            loc: loc,
            isSpecialTag,
            brand_name: brandName,
            is_no_card: isNoCard,
            line_ship_label,
            overtime: convertDateOverTimeNew(remaining_time > 0 ? -remaining_time : overtime),
            tagMTUS: (Array.isArray(genericTags) && genericTags.includes('MT_US_NHE')) ? "MT_US_NHE" : "",
            hwUSPSArea,
            isFastProduction,
            isCutoff,
            isHQ,
            order_type,
            isCombineShip: hasCombineShipTag,
            comboTag: comboTag,
            isCombo: comboTag.length > 0,
            genericTags,
            tags,
            combineShipId: combineShipId,
        }
    }
}

const _handlePrintLabels = async (order, pos) => {
    try {
        const label = _parseLabel(order, pos)
        if (!label) {
            throw new Error('Không thể gen QR.')
        }

        const image = await makeImageLabels([label], true, 560, 300)

        printImage(image)
    } catch (e) {
        console.log(e)
        alert(e.message)
    }
}


export default (order, pos) => {
    return _handlePrintLabels(order, pos)
}

